<template>
  <div>
    <workplace-list :institution-id="institutionData.id" />
  </div>
</template>

<script>
import WorkplaceList from './workplace-list/WorkplaceList.vue'

export default {
  components: {
    WorkplaceList,
  },
  props: {
    institutionData: {
      type: Object,
      required: true,
    },
  },
  setup() {
    return {
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
